import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  standalone: false,
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  ribbonEnv: string;

  constructor() {}

  ngOnInit(): void {
    this.ribbonEnv = this.resolveRibbonLabel();
  }

  private resolveRibbonLabel(): string {
    if (environment.ribbonLabel) {
      return environment.ribbonLabel;
    }

    const normalizedName = (environment.name || '').toLowerCase();
    if (normalizedName.includes('local')) {
      return 'local';
    }
    if (normalizedName.includes('dev')) {
      return 'development';
    }
    if (normalizedName.includes('staging')) {
      return 'staging';
    }
    return '';
  }
}
